import { Fragment, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FormControl, Stack, TextField, Typography, Button, Autocomplete, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { v4 as uuidv4 } from 'uuid';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import './components/style.css';
import { useForm } from "../../hooks/useForm";
import { DataForm } from "./components/DataForm";
import { PriceForm } from "./components/PriceForm";
import { messagesEditEstimate } from "../../helpers/estimateMessage";
import { Message } from "../../components/Message";

import useFetch from "../../hooks/useFetch";
import { urlProduct } from "../../helpers";

export const EditEstimate = ({ data }) => {

    const { data: dataProduct } = useFetch(urlProduct, 'GET');
    const dataForm = { ...data[0], 'tel': data[0].telContact, 'address': data[0].addressWork };
    const dataClient = [];
    dataClient.push(data[0].client);
    const navigate = useNavigate();

    const [formValues, handleInputChange] = useForm(dataForm)

    const { client, status, firstDate, lastDate } = formValues;
    const [completeForm, setCompleteForm] = useState(null)
    const [closeMessage, setCloseMessage] = useState(true)

    useEffect(() => {
        if (typeof formValues?.rents === 'string') {
            handleInputChange({ 'target': { 'name': 'rents', 'value': JSON.parse(formValues.rents) } })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        const id = data[0].clientId ? data[0].clientId : data?.filter((el) => el.name === client)[0]?.id;
        setCompleteForm({ ...formValues, inputFields, 'clientId': id })
    }

    //form

    const [inputFields, setInputFields] = useState(JSON.parse(dataForm.product));

    const handleChangeInput = (id, event) => {
        const newInputFields = inputFields.map(i => {

            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })

        setInputFields(newInputFields);
    }

    const handleAddFields = () => {
        setInputFields([...inputFields, { id: uuidv4(), product: '', amount: '', priceProduct: '', measure: '' }])
    }

    const handleRemoveFields = id => {
        const values = [...inputFields];
        values.splice(values.findIndex(value => value.id === id), 1);
        setInputFields(values);
    }

    const onChange = (e) => {
        handleInputChange({
            target: {
                name: 'dates',
                value: e
            }
        })
    }

    return (
        <Fragment>
            {!completeForm ?
                <section className="section_formEstimate">
                    <FormControl component='form' className="form_containerEstimate" onSubmit={handleSubmit}>
                        <Stack spacing={4} pt={5} pb={3}>
                            <Typography textAlign='center' variant="h5" color="primary">Editar Presupuesto</Typography>

                            <DataForm formValues={formValues} data={dataClient || data} handleInputChange={handleInputChange} />
                            <Stack flexDirection='row' width='100%' justifyContent='space-around' flexWrap='wrap'  >
                                <Stack width='80%'>
                                    <Typography textAlign='center' mb='2rem' variant="subtitle" color="primary">Servicios</Typography>
                                </Stack>
                                <Stack width='100%' alignItems='center' >
                                    {inputFields.map(inputField => (
                                        <Stack width='80%' alignItems='center' gap={2} key={inputField.id} flexDirection='row' justifyContent='space-between'>
                                            {dataProduct && inputField &&
                                                <Autocomplete
                                                    disablePortal
                                                    options={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('')}
                                                    sx={{ width: '160px' }}
                                                    size='small'
                                                    renderInput={(params) => <TextField name='product'{...params}
                                                        value={inputField.product}
                                                        label="Producto" variant="standard" required />}
                                                    onSelect={event => handleChangeInput(inputField.id, event)}
                                                    value={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).includes(inputField.product) ? inputField.product : ''}
                                                />}
                                            <Autocomplete
                                                disablePortal
                                                options={['m2', 'ud', 'm3', '']}
                                                sx={{ width: 130 }}
                                                size='small'
                                                renderInput={(params) => <TextField name='measure'{...params} label="Unidad" required variant="standard" />}
                                                onSelect={event => handleChangeInput(inputField.id, event)}
                                                value={['m2', 'ud', 'm3'].includes(inputField.measure) ? inputField.measure : ''}
                                            />
                                            <TextField
                                                name="amount"
                                                label="Cantidad"
                                                variant="standard"
                                                value={inputField.amount}
                                                onChange={event => handleChangeInput(inputField.id, event)}
                                                type="number"
                                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                                sx={{ width: '100px' }}
                                                required
                                            />
                                            <TextField
                                                name="priceProduct"
                                                label="Precio/ud"
                                                variant="standard"
                                                value={inputField.priceProduct}
                                                onChange={event => handleChangeInput(inputField.id, event)}
                                                type="number"
                                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                                sx={{ width: '100px' }}
                                                required
                                            />
                                            <Stack direction='row'>
                                                <IconButton disabled={inputFields.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                                                    <DeleteIcon color='primary' />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleAddFields}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </Stack>
                                        </Stack>
                                    ))}
                                </Stack>
                                {
                                    status === 'Aceptado' &&
                                        <Stack flexDirection='row' mt={5} width='100%' justifyContent='space-around' flexWrap='wrap' >
                                            <Stack flexDirection='row' width='80%' justifyContent='flex-start' gap={2} alignItems='flex-end' >
                                                <label >Fecha de alquiler:</label >
                                                <DateRangePicker required format='dd/MM/yyyy' onChange={onChange} value={[firstDate, lastDate] || ['', '']} />
                                            </Stack>
                                        </Stack>
                                }
                            </Stack>

                            <PriceForm dataProduct={dataProduct} formValues={formValues} handleInputChange={handleInputChange} />

                            <Stack flexDirection='row' mb='2rem' flexWrap='wrap' justifyContent='flex-end' width='90%' gap={5}>
                                <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={() => navigate('/estimate')}>Cancelar</Button>
                                <Button sx={{ width: '100px' }} variant="contained" size='small' type='submit'>Guardar</Button>
                            </Stack>
                        </Stack>
                    </FormControl >
                </section>
                :
                <Fragment>
                    {closeMessage && <Message messages={messagesEditEstimate} method='PUT' setIsCreate={setCloseMessage} body={completeForm} />}
                </Fragment>
            }
        </Fragment>
    )
}